import { z } from 'zod';

import { CatalogItemStatusSchema } from '../services/catalog-item-status.schema.js';

export const CatalogDefaultAccountKeySchema = z.string().trim().min(1).max(128);

export const CatalogDefaultAccountKeysBodySchema = z.object({
  defaultRevenueAccountKey: CatalogDefaultAccountKeySchema.nullable().optional(),
  defaultInboundAccountKey: CatalogDefaultAccountKeySchema.nullable().optional(),
  defaultCogsAccountKey: CatalogDefaultAccountKeySchema.nullable().optional(),
});

/** BR-PRD-29 — overlay: nome balcão preservado + canônico global exposto lado a lado. */
export const ProductCatalogOverlaySchema = z.object({
  id: z.uuid(),
  canonicalName: z.string(),
  status: z.enum(['UNVERIFIED', 'VERIFIED', 'MERGED']),
  ean: z.string().nullable(),
  brandName: z.string().nullable(),
  mpn: z.string().nullable(),
});

/** BR-PRD-73 — terceiro nível da leitura resolvida (genérico). */
export const ProductGenericOverlaySchema = z.object({
  id: z.uuid(),
  canonicalName: z.string(),
  categoryId: z.uuid(),
  categoryName: z.string().nullable(),
  ncmCode: z.string().nullable(),
  cestCode: z.string().nullable(),
  usefulLifeMonths: z.number().int().nullable(),
  usefulLifeMeters: z.number().int().nullable(),
  warrantyMonths: z.number().int().nullable(),
  warrantyMeters: z.number().int().nullable(),
});

export const ProductResponseSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  normalizedName: z.string(),
  sku: z.string().nullable(),
  stockControl: z.boolean(),
  status: CatalogItemStatusSchema,
  categoryId: z.uuid().nullable(),
  categorySlug: z.string().nullable(),
  categoryName: z.string().nullable().optional(),
  parentCategoryName: z.string().nullable().optional(),
  productTypeId: z.uuid().nullable(),
  productTypeSlug: z.string().nullable(),
  brandId: z.uuid().nullable(),
  brandSlug: z.string().nullable(),
  manufacturerId: z.uuid().nullable(),
  catalogManufacturerId: z.uuid().nullable(),
  manufacturerSlug: z.string().nullable(),
  measurementUnitId: z.uuid().nullable(),
  catalogMeasurementUnitId: z.uuid().nullable(),
  measurementUnitCode: z.string().nullable(),
  manufacturerCode: z.string().nullable(),
  packageBarcode: z.string().nullable(),
  unitBarcode: z.string().nullable(),
  qrCode: z.string().nullable(),
  grossWeightGrams: z.number().int().nullable(),
  netWeightGrams: z.number().int().nullable(),
  usefulLifeMeters: z.number().int().nullable(),
  usefulLifeMonths: z.number().int().nullable(),
  alertMeters: z.number().int().nullable(),
  alertMonths: z.number().int().nullable(),
  warrantyMonths: z.number().int().nullable(),
  warrantyMeters: z.number().int().nullable(),
  warrantyTerms: z.string().nullable(),
  notes: z.string().nullable(),
  defaultRevenueAccountKey: CatalogDefaultAccountKeySchema.nullable(),
  defaultInboundAccountKey: CatalogDefaultAccountKeySchema.nullable(),
  defaultCogsAccountKey: CatalogDefaultAccountKeySchema.nullable(),
  privateFlag: z.boolean(),
  catalogProduct: ProductCatalogOverlaySchema.nullable(),
  genericProduct: ProductGenericOverlaySchema.nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type ProductCatalogOverlay = z.infer<typeof ProductCatalogOverlaySchema>;
export type ProductGenericOverlay = z.infer<typeof ProductGenericOverlaySchema>;
export type ProductResponse = z.infer<typeof ProductResponseSchema>;
